import { render } from "./distributeTsk.vue?vue&type=template&id=4c96ef02&scoped=true"
import script from "./distributeTsk.vue?vue&type=script&lang=js"
export * from "./distributeTsk.vue?vue&type=script&lang=js"

import "./distributeTsk.vue?vue&type=style&index=0&id=4c96ef02&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c96ef02"]])

export default __exports__